import CreateTeamIcon from './CreateTeamIcon';

export default CreateTeamIcon;
